<template>
  <Select
    v-model="selected"
    :options="countries"
    filter
    :empty-filter-message="t('common.noResults')"
    :show-clear="false"
    :placeholder="t('enquiryForm.country')"
    option-label="name"
    fluid
    :class="classes"
    :size="size"
    :virtual-scroller-options="{ itemSize: 40 }"
    :invalid="invalid"
    :pt="{
      label: { class: '!text-sm' },
    }"
  >
    <template #value="slotProps">
      <div v-if="slotProps.value" class="flex items-center gap-2">
        <Image :alt="slotProps.value.name" :src="getFlagUrlByCode(slotProps.value.code)" class="w-5" />
        <span>{{ slotProps.value.name }}</span>
      </div>
      <span v-else>{{ slotProps.placeholder }}</span>
    </template>
    <template #option="slotProps">
      <div class="flex items-center gap-2">
        <Image :alt="slotProps.option.name" :src="getFlagUrlByCode(slotProps.option.code)" class="w-5" />
        <span>{{ slotProps.option.name }}</span>
      </div>
    </template>
  </Select>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { Image, Select } from 'primevue'
import { getFlagUrlByCode } from '@/utils/helpers'
import { loadCountries } from '@/data/countries/index.js'

const props = defineProps({
  modelValue: { type: Object, default: null },
  size: { type: String, default: 'md' },
  classes: { type: String, default: '' },
  invalid: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue'])
const { t, locale } = useI18n({ useScope: 'global' })

const countries = ref([])

watch(
  locale,
  async (val) => {
    countries.value = await loadCountries(val)
  },
  { immediate: true }
)

const selected = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>
